var map = {
	"./AppStore.jpg": 3945,
	"./EpicGames.jpg": 6749,
	"./GOG.jpg": 4676,
	"./GooglePlay.jpg": 5750,
	"./NintendoStore.jpg": 8255,
	"./OIP.jpg": 7477,
	"./PlayStationStore.jpg": 5800,
	"./R.jpg": 335,
	"./Steam.jpg": 665,
	"./Untitled Diagram - diagrams.net_files/404-error-page-not-found.jpg": 2636,
	"./Untitled Diagram - diagrams.net_files/My video store game(1).jpg": 5796,
	"./Untitled Diagram - diagrams.net_files/My video store game.jpg": 8344,
	"./Untitled Diagram - diagrams.net_files/bandicam 2023-02-02 22-16-15-346(1).jpg": 6911,
	"./Untitled Diagram - diagrams.net_files/bandicam 2023-02-02 22-16-15-346.jpg": 8421,
	"./XboxStore.jpg": 5611,
	"./itch.io.jpg": 5829,
	"./playstation-store.jpg": 4735,
	"./th (1).jpg": 6603,
	"./th.jpg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2930;